import React from 'react';

import { FormContainerProps } from '@occc-app/offerHelpers/types';
import { useGetConfigureFormProps } from '@occc-app/offerHelpers/hooks/useGetConfigureFormProps';

import { LoyaltyEventConfigureForm } from './LoyaltyEventConfigureForm';
import { transformOfferToInitialValues } from './utils/configureFormInitialValues';
import { getConfigureFormOperations } from './utils/configureFormOperations';

import {
  LoyaltyEventConfigureFormInitialValues,
  LoyaltyEventConfigureFormValues,
} from '../../types';

export const LoyaltyEventConfigureFormContainer: React.FC<FormContainerProps> = (props) => {
  const configureProps = useGetConfigureFormProps<
    LoyaltyEventConfigureFormValues,
    LoyaltyEventConfigureFormInitialValues
  >(props, transformOfferToInitialValues, getConfigureFormOperations);

  return <LoyaltyEventConfigureForm {...configureProps} />;
};
